import pythonApiClient from './pythonBaseApi';

// Usar cliente base compartido de Python API
const basePath = '/mantenimientos/tipos-origen-trabajadores';

export const tipoOrigenTrabajadorApi = {
  // Obtener todos los tipos de origen
  getAll: async () => {
    const response = await pythonApiClient.get(`${basePath}/`);
    return response.data;
  },

  // Obtener tipo de origen por ID
  getById: async (id) => {
    const response = await pythonApiClient.get(`${basePath}/${id}`);
    return response.data;
  },

  // Crear tipo de origen
  create: async (data) => {
    const response = await pythonApiClient.post(`${basePath}/`, data);
    return response.data;
  },

  // Actualizar tipo de origen
  update: async (id, data) => {
    const response = await pythonApiClient.put(`${basePath}/${id}`, data);
    return response.data;
  },

  // Eliminar tipo de origen
  delete: async (id) => {
    const response = await pythonApiClient.delete(`${basePath}/${id}`);
    return response.data;
  },
};

